export default {"src":"/_next/static/media/eco-lodge.c6fa57b3.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};